import React, { useEffect, useState } from "react";
import { BrandLogos3D } from "./Logo3D";

/**
 * BrandLogo — sidebar brand lockup: the real company logos, full color,
 * spinning in 3D like a coin, ONE AT A TIME cycling the three sister
 * companies.
 *
 * It watches the template's sidebar state (data-sidebar-size on <html>) and
 * renders a genuinely SMALLER logo with NO label/dots when the sidebar is
 * collapsed ("sm-hover" / "sm-hover-active"), and the full cycling logo +
 * label when expanded ("lg"). This avoids CSS-scaling a big canvas (which made
 * the icon look tiny/inconsistent) — the canvas itself is sized to the state.
 *
 * Drop-in (same props). Sidebar.js renders one instance.
 */

function useSidebarCollapsed() {
  const read = () => {
    if (typeof document === "undefined") return false;
    const s = document.documentElement.getAttribute("data-sidebar-size") || "";
    return s === "sm-hover" || s === "sm-hover-active" || s === "sm";
  };
  const [collapsed, setCollapsed] = useState(read);
  useEffect(() => {
    const el = document.documentElement;
    const obs = new MutationObserver(() => setCollapsed(read()));
    obs.observe(el, { attributes: true, attributeFilter: ["data-sidebar-size"] });
    setCollapsed(read());
    return () => obs.disconnect();
  }, []);
  return collapsed;
}

const BrandLogo = () => {
  const collapsed = useSidebarCollapsed();

  // Collapsed: a clear, steady small logo (no spin, so it never catches the
  // coin's edge-on moment and vanishes), no label/dots.
  // Expanded: larger spinning coin + label + dots.
  const size = collapsed ? 48 : 64;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        textDecoration: "none",
        lineHeight: 1,
      }}
    >
      <BrandLogos3D
        size={size}
        secPerTurn={7}
        holdMs={3600}
        labels={!collapsed}
        showDots={!collapsed}
        spin={!collapsed}
      />
    </span>
  );
};

export default BrandLogo;
